import React, { useState } from "react";
import "./contact.scss";

export default function Contact() {
  const [message, setMessage] = useState(false);
  const handleSubmit = (e) => {
    e.preventDefault();
    setMessage(true);
  };
  return (
    <>
      <div className="contact" id="contact">
        <div className="left">
          <img src="assets/shake.svg" alt="" className="s" />
        </div>
        <div className="right">
          <h2>Contact</h2>
          <form onSubmit={handleSubmit}>
            <input type="text" />
            <textarea placeholder="Message"></textarea>
            <button type="submit">Send</button>
            {message && (
              <span style={{ color: "grean" }}>Thanks's I'll reply Soon</span>
            )}
          </form>
        </div>
      </div>
    </>
  );
}
